import ReadArticlePreviewCard from "../ReadArticlePreviewCard/ReadArticlePreviewCard";
import ReadArticleListNav from "./ReadArticleListNav";
import { v4 as uuidv4 } from 'uuid';

import stripHtml from "../../../Components/StripHTML";

export default function ReadArticleList({nonFeatureReads}) {

    return (
        <div className="readArticleList h-auto w-full bg-pink-dashboard rounded-lg gap-2.5 flex flex-col p-4 ">

            <ReadArticleListNav />

            {nonFeatureReads && nonFeatureReads.map((nonFeatureRead) => {

                    const {title, content, date, id, type} = nonFeatureRead

                return (
                    <ReadArticlePreviewCard
                        imgSrc={nonFeatureRead?._embedded?.["wp:featuredmedia"]?.[0]?.source_url ?? null}
                        title={stripHtml(title?.rendered ?? "")}
                        text={content?.rendered ?? ""}
                        authorName={nonFeatureRead?._embedded?.author?.[0]?.name ?? ""}
                        featured={false}
                        key={uuidv4()}
                        date={date ?? null}
                        mediaId={id ?? null}
                        mediaType={type ?? null}
                    />
                );
                }
            )}
        </div>
    );
}

